import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchSupplierNamesAtion = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/suppliers-details`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SUPPLIER_NAMES_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSustainabilityFilterDetailsAtion = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/filter-details`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SUSTAINABILITY_FILTER_DETAILS_ACTION' }, data);
        dispatch(resData);
    };
};


const FetchSustainabilityAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/kpi-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SUSTAINABILITY_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}


const FetchSustainabilityDropdownDetailsAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/dropdown-filters`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchSustainabilitySupplierDetails = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/sustainability/suppliers-details`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SUSTAINABILITY_SUPPLIERS_ACTION' }, data);
        dispatch(resData);
    };
}

export {
    FetchSustainabilityAction,
    FetchSupplierNamesAtion,
    FetchSustainabilityFilterDetailsAtion,
    FetchSustainabilityDropdownDetailsAction,
    FetchSustainabilitySupplierDetails
}